import React, { useContext, useEffect, useRef, useState } from "react";
import { Button } from "antd";
import { Card, Carousel } from "antd";
import classes from "./Onboarding.module.css";
import { CarouselRef } from "antd/es/carousel";
import onbordingImage1 from "./assets/onBoarding1.png";
import onbordingImage2 from "./assets/onBoarding2.png";
import onbordingImage3 from "./assets/onBoarding3.png";
import logo from "./assets/logo.png";
import { updateUserOnboardingStatus } from "api/userData";
import { useGetIdentity } from "@refinedev/core";
import { useLocation, useNavigate } from "react-router-dom";

type OnBoardingContentProps = {
  heading: string;
  subHeading: string | React.ReactNode;
  imageSrc: string;
  footerText?: string;
  onNextClick: () => void;
  isLastPage?: boolean;
};

const OnBoardingContent = ({
  heading,
  subHeading,
  imageSrc,
  footerText,
  onNextClick,
  isLastPage
}: OnBoardingContentProps) => {
  return (
    <Card
      style={{
        backgroundColor: "#283583",
        border: 0,
        borderRadius: "16px",
        padding: "40px 32px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        maxWidth: "100%",
        justifyContent: "center"
      }}
      styles={{
        body: {
          padding: 0,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          width: "100%",
          justifyContent: "center"
        }
      }}>
      <p className={classes.heading}>{heading}</p>
      <p className={classes.subHeading}>{subHeading}</p>

      <div className={classes.imageContainer}>
        <img src={imageSrc} alt="onboarding" className={classes.image} />
      </div>
      <p className={classes.subHeading}>{footerText}</p>

      <Button className={classes.nextButton} style={{ backgroundColor: "#EB5017" }} onClick={onNextClick}>
        {isLastPage ? "Begin" : "Next"}
      </Button>
    </Card>
  );
};

const onBoardingContentData: Omit<OnBoardingContentProps, "onNextClick">[] = [
  {
    heading: "Welcome to Bia™",
    subHeading:
      "Harness the power of quantum computing today, driven by our award-winning Alquor® core technology",
    imageSrc: onbordingImage1,
    footerText:
      "Access, test, and run experiments on our quantum computer."
  },
  {
    heading: "How it works",
    subHeading:
      "Quantum Cloud Computing Service connects you to our near-term quantum computer, so that you can perform calculations at the speed of light remotely from the convenience of your own computer.",
    imageSrc: onbordingImage2
  },
  {
    heading: "Get started",
    subHeading:
      "Simply input your data or algorithms. Our team of experts is available to assist you in setting up your calculations and interpreting the results.",
    imageSrc: onbordingImage3,
    footerText:
      "With Bia™ Quantum Cloud Computing Service, you can stay on the cutting edge of quantum computing technology and achieve new breakthroughs in your field.",
    isLastPage: true
  }
];

export const CarouselIndicator: React.FC = ({}) => {
  const { data: user } = useGetIdentity<{ id: string }>();
  const state = useLocation().state as { email: string };
  const [currentPosition, setCurrentPosition] = useState(0);
  const ref = useRef<CarouselRef>(null);
  const navigate = useNavigate();

  if(!state?.email) {
    navigate('/', {
      replace: true
    })
    return null;
  }

  const onNextClick = async () => {
    if (currentPosition === 2) {
      await updateUserOnboardingStatus(user?.id || "");
      navigate("/", {
        replace: true
      });
    } else ref.current?.next();

    setCurrentPosition((prev) => prev + 1);
  };

  return (
    <div className={classes.onboardingContainer}>
      <div className={classes.logoContainer}>
        <img src={logo} alt="Quix-Logo" />
      </div>

      <Carousel
        ref={ref}
        className={classes.carousel}
        style={{ margin: "160px 0 20px 0", padding: 0, borderRadius: "16px" }}
        dots={false}
        fade={true}
        autoplay={false}
        adaptiveHeight={true}
        infinite={false}>
        {onBoardingContentData.map((data, index) => (
          <OnBoardingContent key={index} {...data} onNextClick={onNextClick} />
        ))}
      </Carousel>
    </div>
  );
};
